<div [class]="'loader' + getProgressClass()"
  *ngIf="progress !== undefined">
  <div class="overlay"></div>
  <div class="content">
    <ng-container *ngFor="let child of templates">
      <ng-container *ngTemplateOutlet="child"></ng-container>
    </ng-container>
  </div>
  <div class="timer fill">
    <div class="half-circle-left-mask">
      <div class="half-circle-left"></div>
    </div>
    <div class="half-circle-right-mask">
      <div class="half-circle-right"></div>
    </div>
  </div>
</div>
<ng-container *ngFor="let child of templates">
  <ng-container *ngTemplateOutlet="child"></ng-container>
</ng-container>